import { api } from '@/utils/lib/api/api.helpers';
import {
  TUserProfileRequestSchema,
  TUserProfileResponseSchema,
  UserProfileRequestSchema,
  UserProfileResponseSchema,
} from '../schemas/profile.schema';
import { PROFILE_AUTH_ENDPOINT } from '../constants';

const getUserProfile = api<
  TUserProfileRequestSchema,
  TUserProfileResponseSchema
>({
  path: PROFILE_AUTH_ENDPOINT.GET_AUTH_PROFILE,
  method: 'GET',
  requestSchema: UserProfileRequestSchema,
  responseSchema: UserProfileResponseSchema,
});

export const UserProfileService = {
  getUserProfile,
};
